var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"250px"}},[_c('canvas',{ref:"donutChart"}),_c('div',{staticClass:"donut-chart-center"})])
}
var staticRenderFns = []

export { render, staticRenderFns }